export const FETCH_UNREAD_NOTIFICATIONS = 'FETCH_UNREAD_NOTIFICATIONS'
export const FETCH_UNREAD_NOTIFICATIONS_SUCCESS = 'FETCH_UNREAD_NOTIFICATIONS_SUCCESS'
export const FETCH_DISMISSED_NOTIFICATIONS = 'FETCH_DISMISSED_NOTIFICATIONS'
export const FETCH_DISMISSED_NOTIFICATIONS_SUCCESS = 'FETCH_DISMISSED_NOTIFICATIONS_SUCCESS'
export const FETCH_LATEST_NOTIFICATIONS = 'FETCH_LATEST_NOTIFICATIONS'
export const FETCH_LATEST_NOTIFICATIONS_SUCCESS = 'FETCH_LATEST_NOTIFICATIONS_SUCCESS'
export const FETCH_UNREAD_STATUS = 'FETCH_UNREAD_STATUS'
export const FETCH_UNREAD_STATUS_SUCCESS = 'FETCH_UNREAD_STATUS_SUCCESS'
export const MARK_READ = 'MARK_READ'
export const MARK_ALL_READ = 'MARK_ALL_READ'
export const MARK_ALL_SEEN = 'MARK_ALL_SEEN'
export const MARK_ALL_SEEN_SUCCESS = 'MARK_ALL_SEEN_SUCCESS'
